module.exports = __webpack_public_path__ + "img/pin.2c922942.svg";